import React, { useState, useRef, useEffect } from 'react';
import MenuPopupTailwind from '../common/MenuPopupTailwind';
import { useUserDetails } from '../../recoil/hooks/useUserState';
import { Avatar } from '@mui/material';
import { cipherEmail } from '../../utils/security';
// import { IDVerificationBadge } from '@/pages/MyDashboard/UserProfile';

export const UsernameBadge = () => {
  const [user] = useUserDetails();

  return (
    <div className="bg-gradient-to-r  px-2 py-0 w-fit">
      <a className="flex items-center gap-2 " href="#!">
        <p className="text-gray-400 m-0 text-f12">User:</p>
        <p className="dark:text-gray-100 text-black m-0 text-f12 font-semibold">
          {user?.username?.length && user?.username.length > 15
            ? user.username.substring(0, 15) + "..."
            : user?.username}
        </p>
        <button
          onClick={() => {
            navigator.clipboard.writeText(user?.username || "");
          }}
          className="text-gray-500 hover:text-gray-300"
          title="Copy"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.15556 5C6.8605 5 5 6.8605 5 9.15556V12.48C5 14.5149 6.46269 16.2083 8.39406 16.566C8.75174 18.4974 10.4451 19.96 12.48 19.96H15.8044C18.0995 19.96 19.96 18.0995 19.96 15.8044V12.48C19.96 10.4451 18.4974 8.75174 16.566 8.39406C16.2083 6.46269 14.5149 5 12.48 5H9.15556ZM14.8315 8.32444C14.4892 7.35604 13.5657 6.66222 12.48 6.66222H9.15556C7.77853 6.66222 6.66222 7.77853 6.66222 9.15556V12.48C6.66222 13.5657 7.35603 14.4892 8.32444 14.8315V12.48C8.32444 10.1849 10.1849 8.32444 12.48 8.32444H14.8315ZM9.98667 12.48C9.98667 11.103 11.103 9.98667 12.48 9.98667H15.8044C17.1814 9.98667 18.2978 11.103 18.2978 12.48V15.8044C18.2978 17.1814 17.1814 18.2978 15.8044 18.2978H12.48C11.103 18.2978 9.98667 17.1814 9.98667 15.8044V12.48Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </a>
    </div>
  );
};

const ProfilePopup: React.FC = () => {
  const [user, setUser] = useUserDetails();
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);
  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const togglePopup = () => setIsOpen(!isOpen);

  if (user === null) return <></>;
  return (
    <div className="relative" ref={popupRef}>
      {/* Profile Trigger */}
      <div
        className="flex items-center gap-2 px-1 py-1 cursor-pointer rounded-lg transition"
        onClick={togglePopup}
      >
        {/* <img
          alt="Profile"
          src={user?.profilePicture}
          width={42}
          className=" rounded-full object-cover border border-gray-600"
        /> */}
        <Avatar src={user?.profilePicture} className='!h-[30px] !w-[30px]' />
        {/* <span className="text-sm font-medium text-white truncate max-w-[100px]">
          {user.name}
        </span> */}
        {/* <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="currentColor"
          className={`text-gray-300 transition-transform ${isOpen ? 'rotate-180' : ''}`}
        >
          <path d="M12 15L6 9H18L12 15Z" />
        </svg> */}
      </div>

      {/* Popup Menu */}
      {isOpen && (
        <div
          className={`
          absolute right-0 top-12 mt-2 w-[25rem] rounded-[0.6rem]
          rounded-xl shadow-lg z-50 overflow-hidden
           bg-white dark:!bg-[#121212]
        `}
        >
          {/* User Info */}
          <div className="px-[1.2rem] w-full">
            <div className="flex items-center gap-4">
              <Avatar src={user?.profilePicture} />
              <div className="overflow-hidden">
                <p className=" font-semibold dark:text-white text-f16 text-[#111827] truncate">
                  {cipherEmail(user?.email)}
                </p>
                <p className="text-xs p-1 w-full bg-[#01BC8D14] rounded-[0.5rem] text-black truncate">
                  <UsernameBadge />
                </p>
              </div>
            </div>
          </div>

          <MenuPopupTailwind />
        </div>
      )
      }
    </div >
  );
};

export default ProfilePopup;
